const average = array => {
  if (!array || !array.length) return 0
  return array.reduce((a, b) => a + b) / array.length
}

export { average }
